import { useState, useEffect } from "react";
import Image from "next/image";
import style from "./modalWindow.module.scss";
import { useRouter } from "next/router";
import * as ga from "../../lib/ga";
import getCommonLocales from "../../locales/locales_common";
import ReactDOM from "react-dom";

export function ModalWindow({ type, closeModal }) {
	const router = useRouter();

	const { locale } = router;

	const dictionary = getCommonLocales(locale);

	const [selectedItem, setSelectedItem] = useState(null);

	useEffect(() => {
		const modalDataItems = {
			start: {
				title: "FREE FOREVER",
				text: dictionary["Sign in free to Creator: Length of clip 30 sec, 3 photos per day, your own background, and more!"],
				img: "/modal/30sec.png",
			},
			creator: {
				title: null,
				text: `<b>${dictionary["Process with Pro"]}</b><br>${dictionary["Only from $1 per 1 minute and $0.16 per photo.<br>Unlimited videos, best quality of removing and more!"]}`,
				img: "/modal/time.png",
			},
		};

		setSelectedItem(modalDataItems[type]);
	}, [type, dictionary]);

	return (
		<div className={`${style.modal_wrapper} ${style.adaptive_on}`} onClick={() => closeModal()}>
			<div className={style.modal_windows}>
				<button className={style.close} onClick={() => closeModal()}></button>
				{selectedItem && (
					<>
						<div className={style.top}>
							<Image width={96} height={96} src={selectedItem.img} alt={selectedItem.title} />
							{selectedItem.title && <h3>{selectedItem.title}</h3>}
						</div>
						<div className={style.text} dangerouslySetInnerHTML={{ __html: selectedItem.text }} />
					</>
				)}
			</div>
		</div>
	);
}

export function CustomModalWindow(props) {
	return ReactDOM.createPortal(
		<div className={`${style.modal_wrapper}`}>
			<div onClick={() => props.closeModal()} className={style.modalCloseBg}></div>
			<div className={style.modal_windows}>
				<button className={style.close} onClick={() => props.closeModal()}></button>
				{props.children}
			</div>
		</div>,
		document.getElementById("portal")
	);
}

export function CustomModalWindowPortal(props) {
	return ReactDOM.createPortal(
		<div className={`${style.modalWrapperPortal}`}>
			<div onClick={() => props.closeModal()} className={style.modalCloseBg} />

			<div className={`${style.modalWindowsPortal} ${props.transparentBg ? style.transparentBg : ""}`}>
				<button className={style.close} onClick={() => props.closeModal()}></button>
				{props.children}
			</div>
		</div>,
		document.getElementById("portal")
	);
}

export function VideoAddModalWindow(props) {
	return (
		<div className={`${style.modal_wrapper}`}>
			<div onClick={() => props.closeModal()} className={style.modalCloseBg}></div>
			<div className={style.video_add_modal_windows}>
				<button className={style.close} onClick={() => props.closeModal()}></button>
				{props.children}
			</div>
		</div>
	);
}

export function PromoModalWindow({ closeModal }) {
	const router = useRouter();
	const { locale } = router;
	const dictionary = getCommonLocales(locale);

	return (
		<div className={`${style.modal_wrapper}`}>
			<div onClick={closeModal} className={style.modalCloseBg}></div>
			<div className={`${style.modal_windows} ${style.promo}`}>
				<div className={style["promo-close-icon"]} onClick={closeModal}>
					<svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M17.0806 6.26318L12.1167 11.2271L17.1231 16.2334L16.2109 17.1456L11.2046 12.1392L6.2619 17.0819L5.4558 16.2758L10.3985 11.3331L5.39216 6.32682L6.30433 5.41465L11.3106 10.421L16.2745 5.45707L17.0806 6.26318Z"
							fill="#0A0909"
						/>
					</svg>
				</div>
				<Image src={`/modal/promo_modal.png`} alt="promo-success" width={230} height={197} className={style.promoImage} />
				<h3 className={style["promo-title"]}>{dictionary["Your promo code has been successfully applied"] || "Your promo code has been successfully applied"}</h3>
				<p className={style["promo-text"]}>{dictionary["You can check your balance in a Personal account"] || "You can check your balance in a Personal account"}</p>
				<button className={style["promo-btn"]} onClick={closeModal}>
					{dictionary["Great!"] || "Great!"}
				</button>
			</div>
		</div>
	);
}

export const ExtensionModal = ({ closeModal, dictionary }) => {
	const clickForAppButton = (store) => {
		ga.event({ action: store, params: { event_category: "click_for_app_button" } });
	};
	return (
		<CustomModalWindow closeModal={closeModal}>
			<p className={style["extension-text"]}>{dictionary["Use our app to process heif format images"]}</p>
			<a className={style["extension-btn"]} rel="noreferrer nofollow" href="https://apps.apple.com/app/bgrem/id1592658212" target="_blank" onClick={() => clickForAppButton("App Store")}>
				{dictionary["Get our app"].slice(0, -1)}
			</a>
		</CustomModalWindow>
	);
};
